import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import EditFreelancerUserHelper from '../EditFreelancerUserHelper';

export default class PaymentInformationForUSA {
  static returnDescriptionTab() {
    return {
      label: 'USA Payment Information',
      hide: (item) => EditFreelancerUserHelper.isBillingDetailHidden(item, 1),
      fields: [
        {
          fieldName: (item) => item.PaymentCurrencyId,
          label: 'Payment Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
          selectvalues: [151],
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'PaymentMethod',
          label: 'Payment Method',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: EditFreelancerUserHelper.getPaymentMethodSelectOptions,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
      ],
    };
  }
}
